import { store } from 'reduxStore';
import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';

export const getMetricsMetadata = () => {
  const accountId = store.getState().accountInfo.id;
  const projectId = store.getState().projectInfo.id;
  return doGet(`${accountId}/${projectId}/metrics`, LOGGER_TYPE.METRICS);
};
